<template>
  <div class="wrapper photos">
    <h1>Photos - 2020</h1>
    <img src="../assets/photos/all.jpg"/>
    <img src="../assets/photos/dad-wave.jpg"/>
    <img src="../assets/photos/strolling.jpg"/>
    <img src="../assets/photos/water.jpg"/>
    <img src="../assets/photos/eye.jpg"/>
    <img src="../assets/photos/strollers.jpg"/>
    <img src="../assets/photos/sam.jpg"/>
    <img src="../assets/photos/sam-finish.jpg"/>
    <img src="../assets/photos/dad-dog.jpg"/>
    <img src="../assets/photos/dad-finish.jpg"/>
    <img src="../assets/photos/strollers-finish.jpg"/>
    <img src="../assets/photos/andrea.jpg"/>
    <img src="../assets/photos/rocks.jpg"/>
  </div>
</template>

<script>
export default {
  name: 'Photos',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.wrapper.photos {
  padding: 40px 0;
}
.wrapper.photos > img {
    width: 100%;
    max-width: 1100px;
}
</style>
